function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RightToolbar from '@/components/RightToolbar/index.vue';
import ActivityUsers from './components/ActivityUsers.vue';
import { typeOptions, styleOptions } from './enums';
import { activityListApi, activitySetIndexFlagApi, activitySetBannerFlagApi, activityUpdateSortApi, lotteryActivityRecordDrawApi } from '@/api/lotteryAssistant';
import { appCategoryOptions } from "@/views/systemSetting/applet/enums";
import { appletListApi } from "@/api/operation/applet";
export default {
  name: 'ActivityList',
  components: {
    RightToolbar: RightToolbar,
    ActivityUsers: ActivityUsers
  },
  data: function data() {
    return {
      loading: false,
      tab: 'all',
      params: {
        status: '',
        winsStatus: ''
      },
      sortMaps: {
        winTime: {
          value: '',
          descending: '',
          ascending: ''
        }
      },
      appList: [],
      typeOptions: typeOptions,
      styleOptions: styleOptions,
      joinTypeOptions: [{
        label: '立即参与',
        value: 1
      }, {
        label: '消耗积分',
        value: 2
      }, {
        label: '看广告参与',
        value: 3
      }, {
        label: '加客服参与',
        value: 4
      }, {
        label: '打开小程序参与',
        value: 5
      }, {
        label: '消耗积分/看广告参与',
        value: 6
      }],
      assistFlagOptions: [{
        label: '关闭',
        value: 1
      }, {
        label: '开启',
        value: 2
      }],
      statusOptions: [{
        label: '未开始',
        value: 1,
        tag: 'orange'
      }, {
        label: '进行中',
        value: 2,
        tag: 'green'
      }, {
        label: '已结束',
        value: 3,
        tag: 'red'
      }],
      winConfigOptions: [{
        label: '未配置',
        value: 1,
        tag: 'orange'
      }, {
        label: '已配置',
        value: 2,
        tag: 'green'
      }],
      activityUser: {
        show: false,
        id: '',
        type: 'edit'
      }
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '所属应用',
        prop: 'applicationId',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.appList
        }
      }, {
        label: '活动名称',
        prop: 'activityName',
        defaultValue: '',
        type: 'input'
      }, {
        label: '活动类型',
        prop: 'activityType',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.typeOptions
        }
      }, {
        label: '活动样式',
        prop: 'activityStyle',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.styleOptions
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'activityId',
        visible: true,
        label: "\u6D3B\u52A8\u7F16\u53F7",
        width: 70
      }, {
        key: 'activityStyle',
        visible: true,
        label: "\u6D3B\u52A8\u7C7B\u578B",
        width: 90,
        formatter: 'tag',
        formatOptions: {
          list: this.styleOptions
        }
      }, {
        key: 'activityName',
        visible: true,
        label: "\u6D3B\u52A8\u540D\u79F0",
        width: 160
      }, {
        key: 'drawTime',
        visible: true,
        label: "\u6D3B\u52A8\u65F6\u95F4",
        width: 255
      }, {
        key: 'joinType',
        visible: true,
        label: "\u53C2\u4E0E\u6761\u4EF6",
        width: 100,
        formatter: 'text',
        formatOptions: {
          list: this.joinTypeOptions
        }
      }, {
        key: 'assistFlag',
        visible: true,
        label: "\u662F\u5426\u52A9\u529B",
        width: 100,
        formatter: 'text',
        formatOptions: {
          list: this.assistFlagOptions
        }
      }, {
        key: 'realJoinNum',
        visible: true,
        label: "\u53C2\u4E0E\u4EBA\u6570",
        width: 100,
        sortKey: 'realJoinNum'
      }, {
        key: 'winTime',
        visible: true,
        label: "\u5F00\u5956\u65F6\u95F4",
        width: 140,
        sortKey: 'winTime'
      }, {
        key: 'sortTmp',
        visible: true,
        label: "\u6392\u5E8F",
        width: 100,
        sortKey: 'sort'
      }, {
        key: 'indexFlag',
        visible: true,
        label: "\u9996\u9875\u5C55\u793A",
        width: 100
      }, {
        key: 'bannerFlag',
        visible: true,
        label: "\u7F6E\u9876banner",
        width: 100
      }, {
        key: 'winConfig',
        visible: true,
        label: "\u5956\u9879\u72B6\u6001",
        width: 80,
        formatter: 'tag',
        formatOptions: {
          list: this.winConfigOptions
        }
      }, {
        key: 'status',
        visible: true,
        label: "\u72B6\u6001",
        width: 80,
        formatter: 'tag',
        formatOptions: {
          list: this.statusOptions
        }
      }];
    }
  },
  watch: {
    'activityUser.show': {
      handler: function handler() {
        if (!this.activityUser.show) {
          this.refreshList();
        }
      }
    }
  },
  created: function created() {
    this.getAppList();
  },
  methods: {
    getAppList: function getAppList() {
      var _this = this;
      var params = {
        page: 1,
        limit: 1000
      };
      appletListApi(params).then(function (data) {
        _this.appList = (data.list || []).map(function (item) {
          item.label = item.appName;
          item.value = item.id;
          return item;
        });
      });
    },
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getSort: function getSort(sortMap) {
      var res = {};
      for (var key in sortMap) {
        if (sortMap[key]) {
          res.sortField = key;
          res.sortOrder = sortMap[key] === 'ascending' ? 'ASC' : 'DESC';
          break;
        }
      }
      return res;
    },
    getList: function getList(query, sortMap) {
      var params = _objectSpread(_objectSpread(_objectSpread({}, query), this.params), this.getSort(sortMap));
      return activityListApi(params).then(function (res) {
        var list = (res.list || []).map(function (item) {
          item.sortTmp = item.sort;
          item.winConfig = item.activityType === 2 ? item.winConfig : 0;
          return item;
        });
        return {
          list: list,
          total: res.total
        };
      });
    },
    changeTab: function changeTab() {
      if (this.tab === 'all') {
        this.params.status = '';
        this.params.winsStatus = '';
      } else if (this.tab.indexOf('status-') === 0) {
        this.params.status = this.tab.slice('status-'.length);
        this.params.winsStatus = '';
      } else if (this.tab.indexOf('winsStatus-') === 0) {
        this.params.winsStatus = this.tab.slice('winsStatus-'.length);
        this.params.status = this.params.winsStatus == '0' ? '3' : '';
      }
      this.resetList();
    },
    //添加商品
    handleAdd: function handleAdd() {
      //id:商品id，isDisabled：是否能编辑(noEdit不能，edit能)，isChoose：是否是选择商品(choose是，noChoose不是)
      this.$router.push({
        path: "/marketing/lottery-assistant/activity/createActivity/0/add"
      });
    },
    //商品操作
    handleActivity: function handleActivity(row, operate) {
      //id:商品id，operate：操作类型(edit编辑，copy复制，detail详情不可编辑)
      this.$router.push({
        path: "/marketing/lottery-assistant/activity/createActivity/".concat(row.activityId, "/").concat(operate)
      });
    },
    handleActivityUser: function handleActivityUser(row, type) {
      var _this2 = this;
      this.activityUser.id = row.activityId;
      this.activityUser.type = type;
      this.$nextTick(function () {
        _this2.activityUser.show = true;
      });
    },
    handleDrawRun: function handleDrawRun(row) {
      var _this3 = this;
      this.$modal.confirm('是否立即开奖？').then(function () {
        _this3.loading = true;
        return lotteryActivityRecordDrawApi({
          id: row.activityId
        });
      }).then(function () {
        _this3.refreshList();
        _this3.$modal.msgSuccess('开奖成功');
      }).catch(function () {}).finally(function () {
        _this3.loading = false;
      });
    },
    //修改首页状态
    handleIndexFlagChange: function handleIndexFlagChange(row) {
      var _this4 = this;
      var params = {
        id: row.activityId,
        indexFlag: row.indexFlag
      };
      this.loading = true;
      activitySetIndexFlagApi(params).then(function (res) {
        _this4.loading = false;
        _this4.$message.success('更新状态成功');
      }).catch(function () {
        _this4.loading = false;
        _this4.$message.error('更新状态失败');
        row.indexFlag = row.indexFlag ? 0 : 1;
      });
    },
    //修改置顶banner状态
    handleBannerFlagChange: function handleBannerFlagChange(row) {
      var _this5 = this;
      var params = {
        id: row.activityId,
        bannerFlag: row.bannerFlag
      };
      this.loading = true;
      activitySetBannerFlagApi(params).then(function (res) {
        _this5.loading = false;
        _this5.$message.success('更新状态成功');
      }).catch(function () {
        _this5.loading = false;
        _this5.$message.error('更新状态失败');
        row.bannerFlag = row.bannerFlag === 1 ? 2 : 1;
      });
    },
    handleSort: function handleSort(row, index) {
      var _this6 = this;
      if (row.sortTmp !== row.sort) {
        this.loading = true;
        var params = {
          activityId: row.activityId,
          sort: row.sortTmp
        };
        activityUpdateSortApi(params).then(function () {
          row.sort = row.sortTmp;
          _this6.$message.success('更新成功');
        }).catch(function (err) {
          row.sortTmp = row.sort;
          _this6.$message.error('更新失败');
        }).finally(function () {
          _this6.loading = false;
        });
      }
    }
  }
};